import React, { useState } from 'react';
import { X } from 'lucide-react';
const AnnouncementBar = () => {
  // Definindo isVisible como false para que a faixa de aviso não seja exibida
  const [isVisible, setIsVisible] = useState(false);
  if (!isVisible) return null;
  return <div className="relative bg-amber-50 text-amber-800 py-3 px-4 text-center text-sm font-medium w-full z-50" data-id="element-1277">
      <div className="container mx-auto" data-id="element-1278">
        Estamos atualizando a ferramenta. Caso tenha algum erro, tente novamente
        mais tarde.
        <button onClick={() => setIsVisible(false)} className="absolute right-4 top-1/2 transform -translate-y-1/2 text-amber-700 hover:text-amber-900" aria-label="Fechar" data-id="element-1279">
          <X size={18} data-id="element-1280" />
        </button>
      </div>
    </div>;
};
export default AnnouncementBar;